import { createReducer, on } from '@ngrx/store';
import * as AuthActions from './auth.actions';
import { AppUser } from 'src/app/services/auth.service';

export interface AuthState {
  user: AppUser | null;
  error: any;
}

export const initialState: AuthState = {
  user: null,
  error: null,
};

export const authReducer = createReducer(
  initialState,

  // 🔹 Login success → guarda usuario
  on(AuthActions.loginSuccess, (state, { user }) => ({
    ...state,
    user,
    error: null,
  })),

  // 🔹 Login failure → guarda error
  on(AuthActions.loginFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  // 🔹 Logout → limpia usuario
  on(AuthActions.logoutSuccess, (state) => ({
    ...state,
    user: null,
    error: null,
  }))
);
